import type { LayoutLoad } from './$types';
import { getWikiIndex } from '$lib/features/wiki/logic/content';
import { buildSidebar } from '$lib/features/wiki/logic/wiki-index';
import { buildSearchRecords } from '$lib/features/wiki/logic/wiki-search';
import { wikiLocaleFromPathname } from '$lib/features/wiki/logic/wiki-path';

// Wiki generuje się statycznie przy buildzie (SAM-589); dziedziczone przez
// wszystkie strony grupy.
export const prerender = true;

export const load: LayoutLoad = ({ url }) => {
	// Locale z pathname, nie getLocale() — deterministyczne na serwerze,
	// przy prerenderze i na kliencie (event.url zachowuje prefiks /pl).
	const locale = wikiLocaleFromPathname(url.pathname);
	return {
		locale,
		sidebar: buildSidebar(getWikiIndex(), locale),
		searchRecords: buildSearchRecords(getWikiIndex(), locale)
	};
};
